module.exports = __webpack_public_path__ + "static/media/contest-3.5a105322.PNG";